import api from '@/api/axiosApi'
import type {
  UserColumnViewRead,
  UserColumnViewListResponse,
  UserColumnViewCreate,
  UserColumnViewUpdate,
} from '@/types/dag'

// Backend caps `limit` at 200; a user's saved views fit in a single page.
const MAX_VIEWS = 200

export async function fetchViews(): Promise<UserColumnViewRead[]> {
  const { data } = await api.get<UserColumnViewListResponse>('/saved-views', {
    params: { limit: MAX_VIEWS },
  })
  return data.data
}

export async function createView(
  payload: UserColumnViewCreate
): Promise<UserColumnViewRead> {
  const { data } = await api.post<UserColumnViewRead>('/saved-views', payload)
  return data
}

export async function updateView(
  viewId: string,
  payload: UserColumnViewUpdate
): Promise<UserColumnViewRead> {
  const { data } = await api.patch<UserColumnViewRead>(
    `/saved-views/${viewId}`,
    payload
  )
  return data
}

export async function deleteView(viewId: string): Promise<void> {
  await api.delete(`/saved-views/${viewId}`)
}
